import React from 'react';

import { AccountContext } from './AccountContext';

export const useAccountContext = () => React.useContext(AccountContext);
